import { Goal, GoalSortingMode, ID, OrderDirection } from '@griply/types';

import { getOrderedGoalIds } from '../get-ordered-goal-ids';
import { sortGoals } from '../sort-goals';

export type GetGoalListOrderOptions = {
  goals: Goal[];
  allGoals: Goal[];
  sortMode: GoalSortingMode;
  sortDirection: OrderDirection;
  goalSorting?: ID[] | null;
};

export const getGoalListOrder = ({
  goals,
  allGoals,
  sortMode,
  sortDirection,
  goalSorting,
}: GetGoalListOrderOptions): ID[] | undefined => {
  if (sortMode === GoalSortingMode.Custom) {
    return goalSorting ?? undefined;
  }

  const sorted = sortGoals(goals, { allGoals, sortMode });
  return getOrderedGoalIds(sorted, sortMode, sortDirection);
};
